import html2canvas from "html2canvas";

const handleExportImage = async (elem, toast) => {
  let canvas = html2canvas(elem.current,{scale:2});
  toast.promise(canvas, {
    loading: "Exporting...",
    success: "Exported",
    error: "Error while exporting",
  });
  canvas = await canvas;
  const dataUrl = canvas.toDataURL("image/png");
  let blobBin = atob(dataUrl.split(",")[1]);
  let array = [];
  for (var i = 0; i < blobBin.length; i++) {
    array.push(blobBin.charCodeAt(i));
  }
  let imageFile = new Blob([new Uint8Array(array)], { type: "image/png" });
  let imageUrl = URL.createObjectURL(imageFile);
  return { imageUrl, imageFile };
};

export const handleExport = (
  elem,
  codeExport,
  setCodeExport,
  resizeX,
  resizeY,
  toast
) => {
  return new Promise(async (resolve, reject) => {
    resizeX.current.classList.add("opacity-0");
    resizeY.current.classList.add("opacity-0");

    let tempState = { ...codeExport };

    let { imageUrl, imageFile } = await handleExportImage(elem, toast);
    tempState.imageUrl = imageUrl;
    tempState.imageFile = imageFile;
    tempState.width = `${elem.current.clientWidth}px`;
    tempState.height = `${elem.current.clientHeight}px`;
    setCodeExport(tempState);
    resizeX.current.classList.remove("opacity-0");
    resizeY.current.classList.remove("opacity-0");
    resolve();
  });
};

export const handleImageCopy = async (imageFile) => {
  await navigator.clipboard.write([
    new window.ClipboardItem({ "image/png": imageFile }),
  ]);
};

export const handleImageDownload = async (imageUrl, fileName) => {
  const link = document.createElement("a");
  link.href = imageUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
